<template>
    <div class="loginBG">
        <div class="contentbox">
            <div class="contItem">
                <div class="leftBox">
                    <!-- <div class="topTime">
                        <div class="times">{{isDownNum}}</div>
                        <div class="timeInfo">下一个倒计时</div>
                    </div> -->
                    
                     
                    <div class="numberC">
                        <!-- <span>{{ currentWordIndex+1 }}</span>/<span>{{ wordList.length }}</span> -->
                    </div>
                    <div class="wordBox" v-if="isOver" ><span style="font-size:40px">朗读结束</span></div>
                    <div class="wordBox" v-if="!isOver && !isShowAll" >
                        <span :style="{fontSize:value6+'px'}" v-if="isENshow">{{newWord.word}}</span> 
                        <span v-if="newWord.phonetic && isYBshow" :style="{fontSize:value6+'px'}">/{{newWord.phonetic}}/</span>
                        <span class="hanzBox" :style="{fontSize:newWord.translation.length>12?(value6-16)+'px': value6+'px'}" ><span v-if="isCXshow">{{newWord.pos}}</span> <span v-if="isZHshow" >{{newWord.translation}}</span>  </span>
                        <span class="iconabxo" @click="iconabxo"></span>

                    </div>
                    <div class="buttomItems"  v-if="!isOver && !isShowAll">
                        <CheckboxGroup v-model="fruit" @on-change="queryList">
                            <Checkbox label="中文"></Checkbox>
                            <Checkbox label="英文"></Checkbox>
                            <Checkbox label="音标"></Checkbox>
                            <Checkbox label="词性"></Checkbox>
                        </CheckboxGroup>
                        <div> 字体大小：<Input-number :max="200" :min="30" :active-change="false" v-model="value6"></Input-number></div>
                        <div class="sizeBnt" v-if="isSort" @click="sortBtns(0)">乱序练习</div>
                        <div class="sizeBnt" v-if="!isSort" @click="sortBtns(1)">顺序练习</div>
                    </div>
                      <!-- border: 1px solid red;
        box-sizing: ; -->
                     <div class="wordBox2" v-if="!isOver && isShowAll" >
                        <div class="WordPage" v-for="(item,index) in resultList[pageNum]" :key="index" :style="{border:currentWordIndex == item.index?'4px solid red':'',boxSizing:currentWordIndex == index?'border-box':''}" @click="vadiosBox(item)">
                            <div class="indexPg">{{item.index+1}}</div>
                            <div class="zhSize" :style="{fontSize:item.word.length>12?(value7-5)+'px': value7+'px'}" v-if="isENshow">{{item.word}}</div>
                            <div class="wordNe" :style="{fontSize:value7+'px'}" v-if="isZHshow"><span v-if="isCXshow">{{item.pos}}</span> <span  :style="{fontSize:(item.translation.length>10?(value7-8)+'px':value7+'px')}">{{item.translation}}</span>  </div>
                            <div class="vadiosBox"></div>
                        </div>
                     </div>
                      <div class="buttomItems"  v-if="!isOver && isShowAll">
                         <CheckboxGroup v-model="fruit1" @on-change="queryList">
                            <Checkbox label="中文"></Checkbox>
                            <Checkbox label="英文"></Checkbox>
                            <Checkbox label="词性"></Checkbox>
                        </CheckboxGroup>
                        <div>字体大小：<Input-number :max="50" :min="15" :active-change="false" v-model="value7"></Input-number></div>
                        <div class="sizeBnt" v-if="isSort" @click="sortBtns(0)">乱序练习</div>
                        <div class="sizeBnt" v-if="!isSort" @click="sortBtns(1)">顺序练习</div>
                    </div>
                </div>
            <div class="rightBox">
                <!-- <div class="timesNumber"><Icon type="ios-clock" size="30" color="#207DE5" />用时</div>
                <div class="numberItem">
                    <div class="timeItem">{{minutes1}}</div>
                    <div class="timeItem">{{minutes2}}</div>
                    <div class="timeItem1">:</div>
                    <div class="timeItem">{{seconds1}}</div>
                    <div class="timeItem">{{seconds2}}</div>
                </div> -->
               <Dropdown @on-click="checkType" style="margin-top:50px">
                    <Button type="primary" class="goback"><Icon type="ios-arrow-down"></Icon><span v-if="showType ==1">朗读英文</span><span v-if="showType == 2">朗读中文</span><span v-if="showType == 3">朗读英中</span></Button>
                    <DropdownMenu slot="list">
                        <DropdownItem :name='1'>朗读英文</DropdownItem>
                        <DropdownItem :name='2'>朗读中文</DropdownItem>
                        <DropdownItem :name='3'>朗读英中</DropdownItem>
                    </DropdownMenu>
                </Dropdown>
                <Dropdown @on-click="CheckisShowAll">
                    <Button type="primary" class="goback"><Icon type="ios-arrow-down"></Icon><span v-if="!isShowAll">显示单个</span><span v-if="isShowAll">显示全部</span></Button>
                    <DropdownMenu slot="list">
                        <DropdownItem :name='1'>显示单个</DropdownItem>
                        <DropdownItem :name='2'>显示全部</DropdownItem>
                    </DropdownMenu>
                </Dropdown>
                <div class="startBtn" @click="proSubject" v-if="!isShowAll"><Icon type="md-arrow-dropup" style="margin-top:-4px" size="30" />上一个</div>
                <div class="startBtn" @click="nextSubJect" v-if="!isShowAll"><Icon type="md-arrow-dropdown" size="30" />下一个</div>

                 <div class="startBtn" @click="proSubject1" v-if="isShowAll"><Icon type="md-arrow-dropup" style="margin-top:-4px" size="30" />上一页</div>
                <div class="startBtn" @click="nextSubJect1" v-if="isShowAll"><Icon type="md-arrow-dropdown" size="30" />下一页</div>

                 <div class="bottomBox">
                    <span>读</span>
                    <Input-number v-model="value1" :min="1"  :max="10" :active-change="false"  size="large"></Input-number>
                    <span>遍</span>
                </div>
                 <div class="bottomBox">
                    <span>隔</span>
                    <Input-number v-model="value2" :min="1" :max="30" :active-change="false" size="large"></Input-number>
                    <span>秒</span>
                </div>
                 <Button type="primary" class="goback" @click="goback"><Icon v-if="!isPay" type="md-arrow-dropright-circle" /><Icon v-if="isPay" type="md-pause" /> <span v-if="isPay">暂停朗读</span><span v-if="!isPay">自动朗读</span> </Button>
                 <Button type="primary" class="goback" @click="goHome"><Icon type="md-exit" />返回列表</Button>
            </div>
            </div>
            </div>
            <audio ref="audio"  controls="controls" class="audiosBox" @ended="overAudio"></audio>
            <audio ref="audio1"  controls="controls" class="audiosBox" @ended="overAudio1"></audio>
             <div class="payVipBox" v-if="!is_payed">
                <div class="PayBoxs">
                    <div class="payTitle">提示</div>
                    <div class="infosBox">开通会员后即可使用小程序全部功能(包含投屏默写)</div>
                    <div class="payMage">
                        <img src="../assets/pay.png"></img>
                    </div>
                    <div class="buttonTitle">扫码立即开通永久会员</div>
                </div>
                <Button type="primary" class="goback poson" @click="goHome"><Icon type="md-exit" />返回列表</Button>
            </div>
        </div>
</template>
  
  <script>
import axios from "axios";
import qs from "qs"
import ASEUrl from "../cryptojs/secret"
export default {
    data() {
      return {
        value1:2,//多少遍
        value2:5,//间隔
        value3:80,//字体大小
        currentWordIndex: 0, // 当前第n个单词
        wordInfo: {},//请求数据
        wordList: [], // 词语列表
        newWord:'',//当前词语
        SimpleWords:'',//单词列表
        minutes: 0,  
        seconds: 0,
        minutes1: 0,  
        seconds1: 0,
        minutes2: 0,  
        seconds2: 0,
        timer:'',//计时器
        ticket:'',//下载凭证
        wordUrl:'',//下载url
        isNum:'',//第几次
        jsTime:'',//倒计时定时器
        isPay:false,//是否播放
        isDownNum:'',//倒计时
        showType:1,//显示类型
        isMiao:'',
        isOver:false,
        daoTime:'',
        isShowAll:false,
        pageNum:0,
        pageIndex:0,
        resultList:[],
        enTw1:'',
        isPayEn:false,
        isPayOverNum:1,
        is_payed:true,
        value6:75,
        value7:30,
        fruit: ['中文','英文','音标','词性'],
        fruit1: ['中文','英文','词性'],
        isZHshow:true,
        isYBshow:true,
        isENshow:true,
        isCXshow:true,
        isSort:true,
        sType:''
      };
    },
     watch: {
     value1(v,n){
        let that = this
         that.isNum = 1
         that.newWord = that.SimpleWords[that.currentWordIndex]
            that.$refs.audio.pause()
            that.isPay = false
            if(that.showType == 2){
                that.$refs.audio.src = encodeURI(that.wordUrl+'&word='+that.newWord.translation)
            
            }else{
                that.$refs.audio.src = encodeURI(that.wordUrl+'&word='+that.newWord.word)
                
            }
                // that.$refs.audio.play()
        }
        
 },
    created() {
        if(window.localStorage.getItem('pc_severalTimes')){
            this.value1 =Number(window.localStorage.getItem('pc_severalTimes')) 
        }
         if(window.localStorage.getItem('pc_interval')){
            this.value2 = Number(window.localStorage.getItem('pc_interval'))
        }
    },
    mounted() {
        this.id = this.$route.query.id
        // this.showType = this.$route.query.showType
        if(this.$route.query.type){
            this.sType = 3
            this.queryScreenWordList()
        }else{
            this.queryWordList()

        }
        
        this.isDownNum= this.value2 
         this.isQueryVip()
    },
    methods: {
       
        isQueryVip(){
        var that = this
        axios({
            headers:{
               'Content-Type':'application/x-www-form-urlencoded',
                'Authorization': window.localStorage.getItem('sessionId'),
            },
            method: 'GET',
            url: '/v1/user/perm',
            })
            .then((res) => {
                if (typeof res.data === 'string') {
              res.data = JSON.parse(ASEUrl.decrypted(res.data)) 
            } 
                    that.is_payed = res.data.data.is_payed
                })
            .catch((err) => {
                that.$Message.error(err);
            });
        },
        checkType(e){
            this.showType = e
        },
        CheckisShowAll(e){
            this.isShowAll = e == 1? false:true
        },
        goHome(){
            this.$router.push({name:'topicList',query:{qtype:this.$route.query.qtype}})
        },
        startTimer () {
            this.seconds += 1; //秒自增 >=60变成 0秒 分加 1分钟
            if (this.seconds >= 60) {
                this.seconds = 0;
                this.minutes = this.minutes + 1;
            }
            let s = this.seconds
            let m = this.minutes
            if(s>9){
              this.seconds1 = s.toString().substring(0,1)
              this.seconds2 = s.toString().substring(2,1)

            }else{
              this.seconds1 =  '0'
              this.seconds2 = s.toString().substring(0,1)
            }

            if(m>9){
              this.minutes1 = m.toString().substring(0,1)
              this.minutes2 = m.toString().substring(2,1)
            }else{
                this.minutes1 =  '0'
                this.minutes2 = m.toString().substring(0,1)
            }
        },
        goback(){
            let that = this
            this.isPay = !this.isPay
            if(this.isOver){
                this.pageNum = 0
                this.pageIndex = 0
                this.currentWordIndex == 0
            }
            // if(this.pageIndex !=0){
            //     this.currentWordIndex = this.pageIndex
            //     this.newWord = this.SimpleWords[this.currentWordIndex]
            // }
            
            window.localStorage.setItem('pc_severalTimes',this.value1)
            window.localStorage.setItem('pc_interval',this.value2)
            if(this.isPay){
                this.$refs.audio.pause()
                clearTimeout(this.jsTime)
                clearInterval(this.timer)
                clearInterval(this.setint)
                clearTimeout(this.isMiao)
                clearTimeout(this.daoTime)
                clearTimeout(this.enTw1)
                
                this.timer = setInterval(this.startTimer, 1000);
                this.isOver = false
                if(this.currentWordIndex == 0){
                    
                    this.seconds = 0
                    this.seconds1 = 0
                    this.seconds2 = 0
                    this.minutes1 = 0
                    this.minutes2 = 0
                }
                this.newWord = this.SimpleWords[this.currentWordIndex]
               if(that.showType == 2){
                    that.$refs.audio.src = encodeURI(that.wordUrl+'&word='+that.newWord.translation)
                  
                }else{
                    that.$refs.audio.src = encodeURI(that.wordUrl+'&word='+that.newWord.word)
                    
                }
                if(that.showType == 3){
                    this.isPayOverNum = 2
                }
                
                setTimeout(function () {
                    that.$refs.audio.play()
                }, 2000)

            }else{
                // this.currentWordIndex = 0
                this.newWord = this.SimpleWords[this.currentWordIndex]
                clearTimeout(this.jsTime)
                clearInterval(this.timer)
                clearInterval(this.setint)
                clearTimeout(this.daoTime)
                clearTimeout(this.isMiao)
                clearTimeout(this.enTw1)
                this.isDownNum = this.value2
                this.$refs.audio.pause()
                this.isPayOverNum = 1
                
            }
        },
      proSubject() {
        if(this.currentWordIndex == 0){
            this.$Message.warning('当前已经是第一题');
        }else{
            this.$refs.audio.pause()
            this.currentWordIndex = this.currentWordIndex -1
            this.newWord = this.SimpleWords[this.currentWordIndex]
            this.value3 = this.newWord.translation.length < 10? 80:this.newWord.translation.length  < 15? 50:36
            this.isNum = 1
            clearTimeout(this.jsTime)
            clearInterval(this.timer)
            clearInterval(this.setint)
            clearTimeout(this.isMiao)
            clearTimeout(this.daoTime)
            clearTimeout(this.enTw1)
            this.isPay = false
            this.isPayOverNum =1
        }
      },
      nextSubJect(){
        let that = this
        if(this.currentWordIndex == this.wordList.length-1){
            this.$Message.warning('当前已经是最后一题');
        }else{
            this.$refs.audio.pause()
            this.currentWordIndex = this.currentWordIndex +1
            this.newWord = this.SimpleWords[this.currentWordIndex]
            that.value3 = that.newWord.translation.length < 10? 80:that.newWord.translation.length  < 15? 50:36
            this.isNum = 1
            clearTimeout(this.jsTime)
            clearInterval(this.timer)
            clearInterval(this.setint)
            clearTimeout(this.isMiao)
            clearTimeout(this.daoTime)
            clearTimeout(this.enTw1)
            this.isPay = false
            this.isPayOverNum =1
        }
      },
      proSubject1(){
        if(this.pageNum == 0){
            this.$Message.warning('当前已经是第一页');
        }else{
            this.pageNum = this.pageNum-1
            this.pageIndex = 0
            this.$refs.audio.pause()
            this.currentWordIndex = this.pageNum == 0? 0:this.pageNum*8
            this.newWord = this.SimpleWords[this.currentWordIndex]
            this.isNum = 1
            clearTimeout(this.jsTime)
            clearInterval(this.timer)
            clearInterval(this.setint)
            clearTimeout(this.isMiao)
            clearTimeout(this.daoTime)
            clearTimeout(this.enTw1)
            this.isPay = false
        }
      },
      nextSubJect1(){
        if(this.resultList.length == this.pageNum+1){
            this.$Message.warning('当前已经是最后一页');
        }else{
            this.$refs.audio.pause()
            this.pageNum= this.pageNum+1
            this.pageIndex = 0
            this.currentWordIndex = this.pageNum*8
            this.newWord = this.SimpleWords[this.currentWordIndex]
            this.isNum = 1
            clearTimeout(this.jsTime)
            clearInterval(this.timer)
            clearInterval(this.setint)
            clearTimeout(this.isMiao)
            clearTimeout(this.daoTime)
            clearTimeout(this.enTw1)
           
            this.isPay = false
        }
      },
        overAudio(){
            const that = this
            //   if(that.isOver){
            //      this.$refs.audio.pause()
            //     return false
            //   }
            if(that.showType == 1 || that.showType == 2 ){
                if(that.isNum > that.value1){
                    that.isNum  = 0
                }
                if(that.isNum == that.value1){
                   
                    that.isNum = 1
                    let num2 = that.value2
                    
                    if(that.currentWordIndex+1 == that.SimpleWords.length){
                        that.isDownNum = that.value2
                        clearTimeout(this.jsTime)
                        clearInterval(this.timer)
                        clearInterval(this.setint)
                        clearTimeout(this.isMiao)
                        that.currentWordIndex = 0
                        that.daoTime = setTimeout(() => {
                            that.isOver = true
                        }, that.value2*1000);
                        this.isPay = false
                    }else{
                        that.setint = setInterval(function(){
                        num2 = num2 -1
                        if(num2 == 0){
                            clearInterval(that.setint)
                            that.isDownNum = that.value2
                        }else{
                            that.isDownNum = num2
                        }
                    },1000)
                        that.jsTime = setTimeout(function(){
                        that.currentWordIndex = that.currentWordIndex+1
                        if(that.pageIndex == 7){
                            that.pageNum = that.pageNum+1
                            that.pageIndex = 0
                        }else{
                            that.pageIndex = that.pageIndex+1
                        }
                        that.newWord = that.SimpleWords[that.currentWordIndex]
                    if(that.showType == 2){
                            that.$refs.audio.src = encodeURI(that.wordUrl+'&word='+that.newWord.translation)
                        
                        }else{
                            that.$refs.audio.src = encodeURI(that.wordUrl+'&word='+that.newWord.word)
                            
                        }
                        that.$refs.audio.play()
                    },that.value2*1000)
                    }
                    
                }else{
                    const that =this
                    this.isMiao = setTimeout(() => {
                        if(that.showType == 2){
                            that.$refs.audio.src = encodeURI(that.wordUrl+'&word='+that.newWord.translation)
                            
                        }else{
                            that.$refs.audio.src = encodeURI(that.wordUrl+'&word='+that.newWord.word)
                            
                        }
                        that.$refs.audio.play()
                        that.isNum = this.isNum+1
                    }, 1000);
                }

            }else if(that.showType == 3){
                if(that.isPayOverNum == that.value1*2){
                    this.isPayOverNum = 1
                        if(that.currentWordIndex+1 == that.SimpleWords.length){
                        clearTimeout(this.jsTime)
                        clearInterval(this.timer)
                        clearInterval(this.setint)
                        clearTimeout(this.isMiao)
                        that.currentWordIndex = 0
                        that.daoTime = setTimeout(() => {
                            that.isOver = true
                             
                        }, that.value2*1000);
                        // that.$refs.audio.src = encodeURI(that.wordUrl+'&word='+that.newWord.translation)
                        // that.$refs.audio.play()
                        this.isPay = false
                    }else{
                        that.isPayEn = true
                        that.jsTime = setTimeout(function(){
                        that.newWord = that.SimpleWords[that.currentWordIndex]
                            that.$refs.audio.src = encodeURI(that.wordUrl+'&word='+that.newWord.translation)
                            that.$refs.audio.play()
                    },1000)
                    }
                }else{
                    const that =this
                    if(that.isPayEn){
                        that.currentWordIndex = that.currentWordIndex+1
                        that.newWord = that.SimpleWords[that.currentWordIndex]
                        that.isPayEn = false
                        if(that.pageIndex == 7){
                            that.pageNum = that.pageNum+1
                            that.pageIndex = 0
                        }else{
                            that.pageIndex = that.pageIndex+1
                        }
                    }
                   
                    this.isMiao = setTimeout(() => {
                        if(that.isPayOverNum % 2 == 1){
                            that.$refs.audio.src = encodeURI(that.wordUrl+'&word='+that.newWord.word)
                        }else if(that.isPayOverNum % 2 == 0){
                            that.$refs.audio.src = encodeURI(that.wordUrl+'&word='+that.newWord.translation)
                        }
                        that.$refs.audio.play()
                        that.isPayOverNum = that.isPayOverNum+1
                    }, 1000);
                }
                 
            }         
            
        },
      
      queryVideoUrl(){
        const that = this
        axios({
          headers:{
            'Content-Type':'application/x-www-form-urlencoded',
            'Authorization': window.localStorage.getItem('sessionId'),
          },
          method: 'GET',
          url: '/v1/export/ticket/'+that.id,
          data:{
            }
          })
        .then((res) => {
            if (typeof res.data === 'string') {
              res.data = JSON.parse(ASEUrl.decrypted(res.data)) 
            } 
            if(res.data.code == 0){
                that.wordUrl = res.data.data.url+'?ticket='+res.data.data.ticket
                if(that.showType == 2){
                    that.$refs.audio.src = encodeURI(that.wordUrl+'&word='+that.newWord.translation)
                }else if(that.showType == 1){
                    that.$refs.audio.src = encodeURI(that.wordUrl+'&word='+that.newWord.word)
                }
                that.isNum = 1
            }else{
                if(res.data.msg == '无效的sessionid'){
                    that.$router.push({name:'login',query:{qtype:this.$route.query.qtype}});
                }else{
                    that.$Message.error(res.data.msg);
                    
                    
                }
            }
            })
        .catch((err) => {
            that.$Message.error(err);
        });
      },
      settimeFunc(){
      },
      overAudio1(){
            const that = this
            if(that.showType == 1 || that.showType == 2 ){
                if(that.isNum == that.value1){
                    return false
                }
                if(that.isNum == that.value1){
                     that.isNum = this.isNum+1
                    that.jsTime = setTimeout(function(){
                    if(that.showType == 2){
                            that.$refs.audio1.src = encodeURI(that.wordUrl+'&word='+that.newWord.translation)
                        }else{
                            that.$refs.audio1.src = encodeURI(that.wordUrl+'&word='+that.newWord.word)
                        }
                        that.$refs.audio1.play()
                    },that.value2*1000)
                }else{
                    const that =this
                    this.isMiao = setTimeout(() => {
                        if(that.showType == 2){
                            that.$refs.audio1.src = encodeURI(that.wordUrl+'&word='+that.newWord.translation)
                        }else{
                            that.$refs.audio1.src = encodeURI(that.wordUrl+'&word='+that.newWord.word)
                        }
                        that.$refs.audio1.play()
                        that.isNum = this.isNum+1
                    }, 1000);
                }

            }else if(that.showType == 3){
                
                if(that.isPayOverNum == that.value1*2){
                    that.isPayOverNum =1
                    return  false
                }
                if(that.isPayOverNum == that.value1*2){
                    this.isPayOverNum = 1
                        that.isPayEn = true
                        that.jsTime = setTimeout(function(){
                        that.newWord = that.SimpleWords[that.currentWordIndex]
                            that.$refs.audio1.src = encodeURI(that.wordUrl+'&word='+that.newWord.translation)
                            that.$refs.audio1.play()
                    },1000)
                }else{
                    const that =this
                    this.isMiao = setTimeout(() => {
                        if(that.isPayOverNum % 2 == 0){
                            that.$refs.audio1.src = encodeURI(that.wordUrl+'&word='+that.newWord.word)
                        }else if(that.isPayOverNum % 2 == 1){
                            that.$refs.audio1.src = encodeURI(that.wordUrl+'&word='+that.newWord.translation)
                        }
                        that.$refs.audio1.play()
                        that.isPayOverNum = that.isPayOverNum+1
                    }, 1000);
                }
                 
            }         
            
        },
      iconabxo(){
        let that =  this
        that.isNum = 1
        this.$refs.audio1.pause()
        if(that.showType == 2){
            that.$refs.audio1.src = encodeURI(that.wordUrl+'&word='+that.newWord.translation)
        }else if(that.showType == 1){
            that.$refs.audio1.src = encodeURI(that.wordUrl+'&word='+that.newWord.word)
        }else if(that.showType == 3){
            that.$refs.audio1.src = encodeURI(that.wordUrl+'&word='+that.newWord.word)
        }
        that.$refs.audio1.play()
      },
      vadiosBox(item){
        let that =  this
         that.isPayOverNum =1
         that.isNum = 1
         that.isPay = false
        //  that.pageIndex = item.index

         that.pageIndex = (item.index+1)%8-1
         that.currentWordIndex = item.index
        that.newWord = item
        clearTimeout(this.jsTime)
        clearInterval(this.timer)
        clearInterval(this.setint)
        clearTimeout(this.isMiao)
        clearTimeout(this.daoTime)
        clearTimeout(this.enTw1)
        this.$refs.audio1.pause()
        this.$refs.audio.pause()
        if(that.showType == 2){
            that.$refs.audio1.src = encodeURI(that.wordUrl+'&word='+that.newWord.translation)
        }else if(that.showType == 1){
            that.$refs.audio1.src = encodeURI(that.wordUrl+'&word='+that.newWord.word)
        }else if(that.showType == 3){
            that.$refs.audio1.src = encodeURI(that.wordUrl+'&word='+that.newWord.word)
        }
        that.$refs.audio1.play()
      },
      queryWordList(){
        const that = this
        axios({
          headers:{
            'Content-Type':'application/x-www-form-urlencoded',
            'Authorization': window.localStorage.getItem('sessionId')
          },
          method: 'GET',
          url: '/v1/dict/'+this.id,
          data:{}
          })
        .then((res) => {
            if (typeof res.data === 'string') {
              res.data = JSON.parse(ASEUrl.decrypted(res.data)) 
            } 
            if(res.data.code == 0){
                that.spinShow = false
                that.wordInfo = res.data.data
                let SimpleWords = res.data.data.dict_info.content || []
                that.SimpleWords = res.data.data.dict_info.content
                that.wordList = SimpleWords
                that.newWord = SimpleWords[that.currentWordIndex]
                that.queryVideoUrl()
                const arr = res.data.data.dict_info.content
                 arr.map((item,index)=>{
                    item.index = index
                })
                const chunkSize = 8;
                const result = [];
                for (let i = 0; i < arr.length; i += chunkSize) {
                    result.push(arr.slice(i, i + chunkSize));
                }
                that.resultList = result
            }else{
                 if(res.data.code == 4001){
                    this.$router.push({name:'login',query:{qtype:this.$route.query.qtype}})
                }else{
                    that.$Message.error(res.data.msg);

                }
            }
            })
        .catch((err) => {
            that.$Message.error(err);
        });
      },
      queryScreenWordList(){
        const that = this
        axios({
          headers:{
            'Content-Type':'application/x-www-form-urlencoded',
           'Authorization': window.localStorage.getItem('sessionId'),
          },
          method: 'GET',
          url: '/v1/screen/'+this.id,
          data:{}                                                                                             
          })                     
          .then((res) => {
            if (typeof res.data === 'string') {
              res.data = JSON.parse(ASEUrl.decrypted(res.data)) 
            } 
            if(res.data.code == 0){
                that.spinShow = false
                that.wordInfo = res.data.data
                let SimpleWords = res.data.data.screen.content || []
                that.SimpleWords = res.data.data.screen.content
                that.wordList = SimpleWords
                that.newWord = SimpleWords[that.currentWordIndex]
                that.queryVideoUrl()
                const arr = res.data.data.screen.content
                 arr.map((item,index)=>{
                    item.index = index
                })
                const chunkSize = 8;
                const result = [];
                for (let i = 0; i < arr.length; i += chunkSize) {
                    result.push(arr.slice(i, i + chunkSize));
                }
                that.resultList = result
            }else{
                 if(res.data.code == 4001){
                    this.$router.push({name:'login',query:{qtype:this.$route.query.qtype}})
                }else{
                    that.$Message.error(res.data.msg);

                }
            }
            })
        .catch((err) => {
            that.$Message.error(err);
        });
      },
      queryList(e){
        let list = e
        list.indexOf('中文')>-1? this.isZHshow = true :this.isZHshow = false
        list.indexOf('英文')>-1? this.isENshow = true :this.isENshow = false
        list.indexOf('音标')>-1? this.isYBshow = true :this.isYBshow = false
        list.indexOf('词性')>-1? this.isCXshow = true :this.isCXshow = false
      },
      randomSort(a, b) { return Math.random() > 0.5 ? -1 : 1; },
       sortBtns(type){
            let that = this
            this.isSort = !this.isSort
            this.isPay = false
            this.$refs.audio.pause()
            that.currentWordIndex =0
            this.isNum = 1
             this.pageIndex = 0
               clearTimeout(this.jsTime)
                clearInterval(this.timer)
                clearInterval(this.setint)
                clearTimeout(this.isMiao)
                clearTimeout(this.daoTime)
            if(type==0){
                if(that.isShowAll){
                    const arr = this.SimpleWords.sort(this.randomSort);
                    arr.map((item,index)=>{
                        item.index = index
                    })
                    const chunkSize = 8;
                    const result = [];
                    for (let i = 0; i < arr.length; i += chunkSize) {
                        result.push(arr.slice(i, i + chunkSize));
                    }
                    that.resultList = result
                    that.newWord = that.resultList[that.currentWordIndex]
                      if(that.showType == 2){
                    that.$refs.audio.src = encodeURI(that.wordUrl+'&word='+that.newWord[0].translation)
                }else{
                    that.$refs.audio.src = encodeURI(that.wordUrl+'&word='+that.newWord[0].word)
                }
                }else{
                     const arr = this.SimpleWords.sort(this.randomSort);
                     this.SimpleWords = arr
                     that.newWord = arr[that.currentWordIndex]
                       if(that.showType == 2){
                            that.$refs.audio.src = encodeURI(that.wordUrl+'&word='+that.newWord.translation)
                        }else{
                            that.$refs.audio.src = encodeURI(that.wordUrl+'&word='+that.newWord.word)
                            
                        }
                }
                    
                
            }else{
        if(this.sType == 3){
            this.queryScreenWordList()
        }else{
            this.queryWordList()
        }
            }

        },
      
    },

  };
  </script>
  <style scoped>
    .loginBG{
        width: 100%;
        height: 100%;
        background: url('https://r.bjwxjs.com/PC_kpy/enPageBackgroundPage.png') 0 0 / 100% 100% no-repeat;
        position: fixed;
        top: 0;
        left: 0;
        bottom: 0;
        right: 0;
    }
    .contentbox{
        padding:50px;
        box-sizing: border-box;
        height: 100%;
        margin:0 auto;
        width: 100%;
    }
    .contItem{
        width: 100%;
        height: 90%;
        display: flex;
        
    }
    .leftBox{
        width: 85%;
        height: 100%;
        /* background: url('https://r.bjwxjs.com/PC_kpy/pc_answerpage.png') 0 0/ 100% 100% no-repeat; */
        position: relative;
    }
    .topTime{
        width: 280px;
        height: 150px;
        background: #207DE5;
        border-radius: 75px;
        position: absolute;
        left: 50%;
        transform: translate(-50%,-50%);
    }
    .times{
        font-size: 90px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #FFFFFF;
        line-height: 100px;
        text-align: center;
        
    }
    .ivu-dropdown-menu{
        width: 160px;
        font-size: 22px;
    }
    .ivu-dropdown-item{
        height: 40px;
        font-size: 24px !important;
        text-align: center;
    }
    .timeInfo{
        font-size: 24px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #FFFFFF;
        text-align: center;
    }
   .numberC{
        font-size: 26px;
        font-family: Helvetica;
        color: #606266;
        padding: 0 60px 0;
        box-sizing: border-box;
        margin-top: 30px;
        
   }
   .wordBox{
        width: 100%;
        height: 100%;;
        text-align: center;
        position: relative;
   }
   .wordBox >span:nth-child(1){
        position: absolute;
        top:30%;
        left: 50%;
        transform: translate(-50%,-50%);
        width: 100%;
        display: inline-block;
        /* font-family: 'pinyin'; */

   }
   .wordBox >:nth-child(2){
        position: absolute;
        top:50%;
        left: 50%;
        transform: translate(-50%,-50%);
        width: 100%;
        display: inline-block;
        /* font-family: 'pinyin'; */

   }
   .wordBox > span:nth-child(3){
        position: absolute;
        top:70%;
        left: 50%;
        transform: translate(-50%,-50%);
        width: 100%;
        display: inline-block;
        /* font-family: 'pinyin'; */

   }
   .wordBox1{
        width: 100%;
        height: 85%;
        overflow: auto;
        display: flex;
        flex-wrap:wrap;
        padding:0 50px 0 100px;

   }
  
   
@media (max-width: 1440px) {
      .wordBox1{
        width: 100%;
        height: 80%;
        overflow: auto;
        display: flex;
        flex-wrap:wrap;
        padding:0 50px 0 100px;
        

   }
} 

   .bottomBox{
        width: 160px;
        height: 50px;
        background: #FCFDFF;
        box-shadow: 0px 2px 5px 0px #95C9FF;
        border-radius: 10px;
        margin-left: 10px;
        display: flex;
        font-size: 20px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #606266;
        text-shadow: 0px 2px 10px #95C9FF;
        line-height: 50px;
        margin:10px 20px 0;
        padding: 0 10px;
        box-sizing: border-box;
   }
   .bottomBox > div{
         width: 160px;
        text-align: center;
   }
   .ivu-input-number-large{
        font-size: 20px;
        margin: 5px 15px;
        text-align: center;
        height: 38px !important;
        line-height: 36px;
        width: 60px !important;
   }
  .bottomBox /deep/ .ivu-input-number-input{
        text-align: center;
        height: 38px !important;
        line-height: 26px;
        width: 60px !important;
   }
   .timesNumber{
        font-size: 26px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #303133;
        text-align: center;
        margin-top: 40px;
        box-sizing: border-box;
   }
   .numberItem{
        display: flex;
        width: 100%; 
        height: 60px;
        margin-top: 10px;
        padding-left: 20px;
        box-sizing: border-box;
   }
   .timeItem{
        width: 36px;
        height: 60px;
        background: rgba(255,255,255,0.8);
        box-shadow: 0px 2px 5px 0px #95C9FF;
        border-radius: 6px;
        border: 2px solid #207DE5;
        font-size: 36px;
        font-family: Arial-BoldMT, Arial;
        font-weight: normal;
        color: #303133;
        line-height: 60px;
        margin-right: 10px;
        text-align: center;
   }
   .timeItem1{
        font-size: 36px;
        font-family: Arial-BoldMT, Arial;
        font-weight: normal;
        color: #303133;
        line-height: 40px;
         margin-right: 10px;
   }
   .startBtn{
        width: 180px;
        height: 60px;
        background: url('https://r.bjwxjs.com/PC_kpy/pc_button_BG@2x.png') 0 0 / 100% 100% no-repeat;
        font-size: 26px;
        font-family: HiraginoSansGB-W6, HiraginoSansGB;
        font-weight: normal;
        color: #207DE5;
        text-align: center;
        line-height: 60px;
        margin-top: 10px;
        margin-left: 10px;
        cursor:pointer;

    }
    .goback{
        width: 160px;
        height: 50px;
        font-size: 20px;
        margin-left:20px;
        line-height: 40px;
        margin-top: 20px;
    }
    .rightBox{
        width: 15%;
    }
    .audiosBox{
        position: fixed;
        left: 0;
        top: 0;
        opacity: 0;
    }
    .worditem{
       margin-right: 16px;
    }
    .worditem >div{
         display: flex;
        flex-wrap: wrap;
    }
     ::-webkit-scrollbar {
      display: none; /* Chrome Safari */
    }
    .pinBox{
        font-size: 26px;
        /* font-family: "pinyin";; */
        color: #000000;
        width: 120px;
        height: 120px;
        line-height: 120px;
        text-align: center;
        background: url('https://r.bjwxjs.com/PC_kpy/IMG_9180.png') center center / 100% 60% no-repeat;
    }
    .pinBox:nth-child(2){
        margin-left: -1px;
    }
    .pinBox:nth-child(3){
        margin-left: -1px;
    }
    .pinBox:nth-child(4){
        margin-left: -1px;
    }
    .ziBox{
        font-size: 45px;
        font-family: ArialMT;
        color: #000000;
        width: 120px;
        height: 120px;
        line-height: 120px;
        text-align: center;
        background: url('https://r.bjwxjs.com/PC_kpy/pc_fangge_icon.png') 0 0 / 100% 100% no-repeat;
    }
    .ziBox:nth-child(2){
        margin-left: -1px;
    }
    .ziBox:nth-child(3){
        margin-left: -1px;
    }
    .ziBox:nth-child(4){
        margin-left: -1px;
    }
    .ivu-dropdown{
        margin: 0 auto;
    }
    .leftBoxs{
        text-align: center;
    }
    .wordBox{

    }
    .wordBox2{
        width: 100%;
        height: 100%;;
        text-align: center;
        padding: 0 30px;
        box-sizing: border-box;

   }
   
    .WordPage{
        position: relative;
        width: 50%;
        height: 25%;
        text-align: center;
        border-bottom: 1px solid #207DE5;
        border-left: 1px solid #207DE5;
        padding: 0 30px;
        float: left;
        font-weight: 600;
        display: flex;
        justify-content: center;
        align-items: center;
        flex-direction:column;

    }
    .WordPage:nth-child(1){
         border-top: 1px solid #207DE5;
    }
    .WordPage:nth-child(2){
         border-top: 1px solid #207DE5;
    }
    .WordPage:nth-child(2n){
        border-right: 1px solid #207DE5;
    }
   
    .WordPage:last-child{
        border-right: 1px solid #207DE5;
    }
    .indexPg{
        width: 45px;
        height: 45px;
        border-radius: 150px;
        box-sizing: border-box;
        border: 1px solid rgba(0,0,0,0.8);
        line-height: 45px;
        text-align: center;
        font-size: 33px;
        position: absolute;
        left: 10px;
        top: 10px;
    }
    .wordNe{
        font-size: 30px;
         display: flex;
        justify-content: center;
        align-items: center;
        width: 100%;
        height: 50%;
    }
    .zhSize{
         font-size: 36px;
         /* width: 100%;
         height: 100%; */
          display: flex;
        justify-content: center;
        align-items: center;
        width: 100%;
        height: 50%;
    }
    .payVipBox{
        position: fixed;
        top: 0;
        left: 0;
        bottom: 0;
        right: 0;
        background:rgba(0, 0, 0, 0.6);
        z-index: 10;
    }
    .PayBoxs{
        width: 500px;
        height: 500px;
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%,-50%);
        background-color: #FFFFFF;
        border-radius: 20px;
    }
    .payTitle{
        font-size: 32px;
        font-weight: 600;
        text-align: center;
        margin-top: 30px;
        color: #333333;
    }
    .infosBox{
        font-size: 24px;
        color: #333333;
        text-indent:2em;
        line-height: 40px;
        padding: 0 30px;
        box-sizing: border-box;
        margin-top: 20px;
    }
    .payMage{
        width: 200px;
        height: 200px;
        margin:20px auto;
    }
    .payMage img{
        width: 100%;
        height: 100%;
    }
    .buttonTitle{
        text-align: center;
        color: #333333;
        font-size: 26px;
    }
    .poson{
        position: absolute;
        bottom: 80px;
        right: 70px;
    }
    .hanzBox{
        height: 150px;
        margin-top: 10px;
    }
    .iconabxo{
        width: 60px !important;
        cursor:pointer;
        height: 60px !important;
        position: absolute;
        top: 80px !important;
        left: 50% !important;
        transform: translate(-50%,-50%) !important;
        background:url('https://r.bjwxjs.com/PC_kpy/autioIconsPc.png') 0 0 /100% 100% no-repeat;
    }
    .vadiosBox{
        width: 30px !important;
        cursor:pointer;
        height: 30px !important;
        position: absolute;
        top: 10px !important;
        right:10px;
        background:url('https://r.bjwxjs.com/PC_kpy/autioIconsPc.png') 0 0 /100% 100% no-repeat;
    }
    .buttomItems{
        position: fixed;
        bottom: 0px;
        left: 50%;
        width: 800px;
        height: 60px;
        background-color: #fff;
        border-radius: 12px;
        transform: translate(-50%,-50%);
        box-shadow: 0px 4px 20px 0px #95C9FF;
        text-align: center;
        font-size: 20px;
        line-height: 60px;
        display: flex;
        flex-direction:row;
        justify-content:space-between;
        padding: 0 50px;
        box-sizing: border-box;
    }
   
    .buttomItems /deep/ .ivu-input-number-input{
        text-align: center;
        font-size: 20px;
   }
   .ivu-checkbox-wrapper {
    font-size: 18px !important;

   }
   .ivu-checkbox-group{
    /* margin:0 60px; */
   }
   .sizeBnt{
    /* position: absolute;
    right: 30px;
    top: 50%;
    transform: translate(0,-50%); */
    width: 120px;
    height: 40px;
    line-height: 40px;
    font-size: 16px;
    padding-left: 30px;
    margin-top:10px;
    cursor: pointer;
    background: url('https://r.bjwxjs.com/PC_kpy/sortPageNums.png') 0 center / 30px 30px no-repeat;
   }
  </style>
  